import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DoctorManagementState } from './types';
import dayjs from 'dayjs';
import { dateFormat } from '../../helper';

// Define the shape of your slice state explicitly for better type safety

const currentDate = dayjs().format(dateFormat.YYYY_MM_DD);
const selectedDate = dayjs().format(dateFormat.YYYY_MM_DD);
// Initial state
const initialState: DoctorManagementState = {
  currentDate: currentDate,
  selectedDate: selectedDate
};

const doctorManagementSlice = createSlice({
  name: 'doctorManagement',
  initialState,
  reducers: {
    setCurrentDate(state, action: PayloadAction<string>) {
      state.currentDate = action.payload;
    },
    setSelectedDate(state, action: PayloadAction<string>) {
      state.selectedDate = action.payload;
    }
  }
});

export const { setCurrentDate, setSelectedDate } = doctorManagementSlice.actions;

export default doctorManagementSlice.reducer;
